import { html, render } from 'lit-html'
import bmbf_logo from '../img/BMBF_transparent.png'

const navItem = () => html`
        <li class="nav-item">
        </li>
        `

const header = (data) =>
    html`

    <div class="navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a id='data-btn' class="nav-link active" href="#">${data.data} </a>
        </li>
        <!-- <li class="nav-item">
          <a id="downloads-btn" class="nav-link" href="#">${data.downloads}</a>
        </li> -->
      </ul>
    </div>

    <div class="navbar-collapse collapse justify-content-center order-2" id="map-title-div">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link disabled" id='map-title' href="#">${data.title}</a>
        </li>
      </ul>
    </div>
    <div class="navbar-collapse collapse justify-content-end order-2" id="collapsingNavbar">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a id='about-btn' class="nav-link" href="#" data-toggle="modal" data-target="#exampleModalLong">${data.about}

          </a>

        </li>
            <!-- <img id="navbar-logo" src=${bmbf_logo}> -->
      </ul>
    </div>
 `

const infoButtonContentHeader = (title, subtitle) =>
    html`
    <h4>${title}</h4>
  <p>${subtitle}</p>`

function infoButtonTable (header, infos) {
    console.log(header)
    console.log(infos)
    return html`
  ${infoButtonContentHeader(header.title, header.subtitle)}
   ${infos.map((item) => html`<div id="container">
    <div id="row">${item.name}
  <hr id ="left">${item.description}
  <hr id ="right">
  </div>`)}
  `
}
function popoverButton (content) {
    const el = document.createElement('template-popover')
    // let content = info_button_content(header,infos)
    render(content, el)
    const elStr = el.innerHTML

    return html`
    <a tabindex="0" class="fas fa-info-circle" role="button" data-toggle="popover" data-trigger="focus"
          data-content=${elStr}></a>
    `
}

export { header, popoverButton, infoButtonTable, infoButtonContentHeader }
